$(document).ready(function(){


(function($) {

    if (typeof $ === 'undefined') {
        return;
    }

})(jQuery);


/**
 * Search form - toggle between Residential and Commercial
 */
function search() {

    var sections = $('.search .section');
    var hidden = '-hidden';
    var active = '-active';
    var pager;
    var toggle;
    var initial;

    if (sections.length === 0) {
        return;
    }

    toggle = function(e) {
        var target = $($(this).attr('href'));
        var others = $('.search .section').not(target);

        e.preventDefault();
        sections.not(target).addClass(hidden);
        sections.not(target).removeClass(active);
        target.removeClass(hidden);
        target.addClass(active);
        pager.find('a').removeClass(active);
        pager.find("a[href='#" + target.attr('id') + "']").addClass(active);
    };

    pager = $('<div class="pager"></div>');
    initial = sections.filter('.-initial');

    if (initial.length === 0) {
        initial = sections.eq(0);
    }

    sections.each(function(index, element) {
        var section = $(element);
        var heading = section.find('h3');
        var text = heading.text();
        var id = section.attr('id');
        var link = $('<a>' + text + '</a>');

        if (!id) {
            id = text.toLowerCase().replace(/[^0-9a-z ]/g, '')
                .replace(/ +/g, '_');
            section.attr('id', id);
        }

        link.attr('href', '#' + id);
        link.on('click', toggle);

        if (index === sections.index(initial)) {
            link.addClass(active);
        }

        heading.empty().append(link);
        pager.append(link.clone(true));
    });

    sections.parent().prepend(pager);
    sections.not(initial).addClass(hidden);
    initial.removeClass(hidden);
    initial.addClass(active);
}



/**
 * Navigation
 */

function menuClass() {

    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    if (width <= em2px(40)) {
        $("#top-bar").addClass("mobile-bar");
        $(".nav").addClass("-closed");
    }
    else {
        $(".nav").removeClass("-closed");
        $("#top-bar").removeClass("mobile-bar");
    }
}



/**
 * Navigation setup
 */

function setupMenu() {

    $('.mobile-bar').on('click', function(){
       $(".nav").toggleClass('-closed');
    });
}


/**
 * Window resize
 */
$(window).resize(function(){
    menuClass();
});


/**
 * Convert pixels to em
 */
function em2px(input) {
    var emSize = parseFloat($("body").css("font-size"));
    return (emSize * input);
}

function propertyTabs() {

    // Hide toggleable sections
    $('.property-tabs a:not([target="_blank"])').each(function(){
        $($(this).attr('href')).hide();
    });

    // Show first toggleable section
    section = $('.property-tabs a:not([target="_blank"])').first().addClass('-active');
    $(section.attr('href')).show();

    // Click event for toggleable sections
    $('.property-tabs a:not([target="_blank"])').bind('click', function(event){

        // Active
        $('.property-tabs a').removeClass('-active');
        $(this).addClass('-active');

        // Hide/show
        if ($(this).attr('href').substr(0,1) == '#') {
            $('.property-content .section').hide();
            $($(this).attr('href')).show();
        }

        // Redraw the map if it's become visible
        if ($(this).attr('href')=='#map')
        {
            $('#map').mapify('redraw');
        }

        event.preventDefault();
    });
}

/**
 * Handle lightboxes
 */
function popups() {

    var iframe = $('.popup-iframe');

    if (iframe.length > 0) {
        iframe.magnificPopup({
            disableOn: 700,
            type: 'iframe',
            removalDelay: 100,
            preloader: false,

            fixedContentPos: false
        });
    }

    var image = $('.popup-image');

    if (image.length > 0) {
        image.magnificPopup({
            type: 'image',
            closeOnContentClick: true,
        });
    }
}

$('.g-map').mapify({
    points: [
        {
            lat: 53.783634,
            lng: -1.072573,
            marker: true,
            title: 'Keith Taylor Estate Agents',
            infoWindow: '<strong>Keith Taylor Estate Agents,</strong><br> 56 Gowthorpe,<br> Selby,<br> North Yorkshire,<br> YO8 4ET',
        }
    ],
    responsive: true,
    zoom: 19,
    key: 'AIzaSyCgF-NCLRDA-NzwHOddUuGrrpRNkc00HCM',
});

$('#map').mapify({
    points: [
        {
            lat: parseFloat($('#map').data('lat')),
            lng: parseFloat($('#map').data('lng')),
            marker: '/static/images/sales-marker.png',
            infoWindow: $('#map').data('caption'),
        }
    ],
    responsive: true,
    zoom: 15,
    key: 'AIzaSyCgF-NCLRDA-NzwHOddUuGrrpRNkc00HCM',
});

if ($('#results_map').length)
{
    // Basically a rewrite of Mapify here.

    // We have a map.

    var bounds = new google.maps.LatLngBounds();
    var points = [];
    var markers = [];
    var windows = [];
    var infoWindow = new google.maps.InfoWindow();

    // Setup map
    var map = new google.maps.Map(document.getElementById('results_map'), {
            zoom: 15,
            center: bounds.getCenter(),
            mapTypeId: google.maps.MapTypeId.ROADMAP
        }
    );

    if (mapdatapoints)
    {

        // Loop through data
        mapdatapoints.forEach(function(property, index) {

            if (property.lat && property.lng)
            {
                // Create points and extend bounds
                points[index] = new google.maps.LatLng(property.lat, property.lng);
                bounds.extend(points[index]);

                // Create marker
                markers[index] = new google.maps.Marker({
                    position: points[index],
                    map: map,
                    title: property.title,
                    icon: '/static/images/sales-marker.png',
                });


                // Configure window event
                google.maps.event.addListener(markers[index], 'click', function() {
                    infoWindow.setContent(property.infoWindow);
                    infoWindow.open(map, markers[index]);
                });
            }
        });
    }

    map.redraw = function() {
        // Fit map to markers
        map.fitBounds(bounds);
        google.maps.event.trigger(map,'resize');
    };
    map.redraw();

    // Set resize listeners for responsive/other redraws

    // Reset map centre after resize complete
    $(window).on('resize', function() {
        doneResize = setTimeout(function() {
            $(window).trigger('doneResize');
        }, 100);
    });

    $(window).on('doneResize', function() {
        map.redraw();
    });

    // Redraw map
    $(window).on('redrawMaps', function() {
        google.maps.event.trigger(map,'resize');
        map.redraw();
    });
}


function propertySlideshows() {
    $('body').on('click', '.cycle-carousel-wrap a', function(event) {
                $('.gallery').cycle('goto', $(this).data('index'));
    });
}

propertySlideshows();
popups();
search();
setupMenu();
menuClass();
propertyTabs();

});